import * as Sentry from '@sentry/react';

export function initSentryReact(): void {
  const config = window.__SENTRY_CONFIG__;
  if (!config?.dsn) return;

  Sentry.init({
    dsn: config.dsn,
    environment: config.environment || undefined,
    release: config.release || undefined,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

export { Sentry };
